import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Avatar,
  Chip,
  Divider,
  Button,
  TextField,
} from '@mui/material';
import { getQuestionById } from '../services/questionService';

const QuestionDetail = () => {
  const { id } = useParams();
  const [question, setQuestion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newAnswer, setNewAnswer] = useState('');

  useEffect(() => {
    fetchQuestion();
  }, [id]);

  const fetchQuestion = async () => {
    try {
      const data = await getQuestionById(id);
      setQuestion(data);
    } catch (error) {
      console.error('Error fetching question:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container>
        <Typography>Loading...</Typography>
      </Container>
    );
  }

  if (!question) {
    return (
      <Container>
        <Typography>Question not found</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            {question.title}
          </Typography>

          <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
            {question.tags?.map((tag) => (
              <Chip key={tag.id} label={tag.name} size="small" />
            ))}
          </Box>

          <Typography variant="body1" sx={{ mb: 3 }}>
            {question.content}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Avatar src={question.author?.avatar_url} />
            <Box>
              <Typography variant="subtitle2">
                {question.author?.username}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Asked {new Date(question.created_at).toLocaleDateString()}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>

      <Typography variant="h5" sx={{ mb: 2 }}>
        {question.answers?.length || 0} Answers
      </Typography>

      {question.answers?.map((answer) => (
        <Card key={answer.id} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {answer.content}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Avatar src={answer.author?.avatar_url} />
              <Box>
                <Typography variant="subtitle2">
                  {answer.author?.username}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Answered {new Date(answer.created_at).toLocaleDateString()}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Your Answer
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          value={newAnswer}
          onChange={(e) => setNewAnswer(e.target.value)}
          placeholder="Write your answer here..."
          sx={{ mb: 2 }}
        />
        <Button variant="contained" color="primary">
          Post Your Answer
        </Button>
      </Box>
    </Container>
  );
};

export default QuestionDetail; 